import { T } from '@tolgee/react';
import { SupplementalKnowledgeValueMessage } from 'services/api/supplementKnowledge';
import emptySvg from 'views/Knowledge/assets/empty.svg';
import { Button, Empty } from 'antd';
import useModal from 'hooks/useModal';
import { LocalMessage } from 'hooks/business/conversation';
import { useGetMessageById } from 'hooks/business/message';
import Feedback from 'views/Conversation/Chat/components/Feedback';

export const EmptyKnowledgePlaceholder = (props: {
  question?: SupplementalKnowledgeValueMessage;
  conversation: Conversation.Conversation;
}) => {
  const { question, conversation } = props;
  const { conversationId, storeId, region, channel, externalBuyerId } = conversation;
  const {
    visible: feedbackVisible,
    show: showFeedback,
    hide: hideFeedback,
    meta: feedbackMessage,
  } = useModal<LocalMessage>();
  const getMessageById = useGetMessageById();

  const handleShowFeedback = () => {
    if (!question) return;

    const cachedMessage = getMessageById(question.messageId);
    if (cachedMessage) {
      showFeedback(cachedMessage);
      return;
    }

    showFeedback({
      msgId: question.messageId,
      textContent: {
        text: question.message,
        originalText: '',
        translationContent: {},
      },
      conversationId,
      storeId,
      fromId: '',
      fromUserName: '',
      toId: '',
      toUserName: '',
      messageType: 'TEXT',
      voucher: false,
      msgFromType: 'BUYER',
      region,
      status: 'SUCCESS',
      channel,
      externalId: externalBuyerId,
      yunXinMsgId: '',
      sendTime: '',
      msgResource: 'CHAT',
      tunnelAccountId: '',
    });
  };

  return (
    <div className="flex flex-col gap-2 py-4">
      <Empty
        image={<img src={emptySvg} alt="empty" />}
        description={
          <T
            keyName="emptyKnowledgeTips"
            params={{
              btn: <Button className="!p-0" type="link" onClick={handleShowFeedback} />,
              br: <br />,
            }}
          />
        }
      />
      {feedbackMessage && (
        <Feedback
          visible={feedbackVisible}
          onCancel={() => hideFeedback()}
          message={feedbackMessage}
          storeName={conversation.topBarInfo?.storeName}
        />
      )}
    </div>
  );
};
